import {useAuthStore} from "./state";

export const useIsLoggedIn = () : boolean => {
    const authStore = useAuthStore();
    return authStore.auth != null;
}
